// Maximum gas limit that can be relayed for No Fee November
export const MAX_GAS_LIMIT_NO_FEE_CAMPAIGN = BigInt(1_000_000) // 1M gas
